import { useState as i } from "react";
const u = 100, C = (s) => {
  const [c, r] = i(0), [l, n] = i(!1);
  return { typewrite: (p, f = 30) => {
    n(!0), r(0), s("");
    const t = p.split(" "), o = () => (r((a) => {
      const e = Math.min(
        a + f * u / 1e3,
        t.length
      );
      return e < t.length ? setTimeout(o, u) : n(!1), s(t.slice(0, e).join(" ")), e;
    }), c);
    o();
  }, isWriting: l };
};
export {
  C as useTypewriterEffect
};
